import { SerializedError } from '@reduxjs/toolkit';
import Dropzone from 'components/Dropzone';
import { acceptedFileTypes } from './constants';
import { useUploadAudioValidation } from './hooks';

interface UploadUserLoopProps {
  onAddFile: (file: File) => void;
  onError: (file: File, error: SerializedError, duration?: number) => void;
}

const UploadUserLoop = ({ onAddFile, onError }: UploadUserLoopProps) => {
  const { onDrop } = useUploadAudioValidation({
    onSuccess: onAddFile,
    onError,
  });

  return (
    <Dropzone noClick accept={acceptedFileTypes} maxFiles={1} onDrop={onDrop} />
  );
};

export default UploadUserLoop;
